import { paletteCommandsStore } from "@/store/palette-commands-store";
import { useEffect, useId, useRef } from "react";
import type { PaletteCommand } from "./types";

export function usePaletteCommands(commands: PaletteCommand[]): void {
  const registrationId = useId();
  const latestCommandsRef = useRef(commands);
  useEffect(() => {
    latestCommandsRef.current = commands;
  });

  const visibleKey = JSON.stringify(
    commands.map((command) => [
      command.id,
      command.title,
      command.subtitle,
      command.keywords,
      command.shortcut,
      "to" in command ? command.to : null,
    ]),
  );

  useEffect(() => {
    const performLatest = (id: string) => {
      const command = latestCommandsRef.current.find((candidate) => candidate.id === id);
      if (command && "perform" in command) command.perform();
    };

    paletteCommandsStore.getState().register(
      registrationId,
      latestCommandsRef.current.map((command) =>
        "perform" in command ? { ...command, perform: () => performLatest(command.id) } : command,
      ),
    );
  }, [registrationId, visibleKey]);

  useEffect(() => () => paletteCommandsStore.getState().unregister(registrationId), [registrationId]);
}
